import { memo } from "react";
import { Close } from "../../icons";
import type { AcceptResponse } from "../../types";
import { Form } from "./Form";

type FormContainerProps = {
  closePopup: () => void;
  setResult: (result: AcceptResponse[]) => void;
};

export const FormContainer = memo(
  ({ closePopup, setResult }: FormContainerProps) => (
    <div className="popup__main">
      <button className="popup__close" onClick={() => closePopup()}>
        <Close />
      </button>
      <div className="popup__content">
        <h2 className="popup__title">Our offer</h2>
        <p className="popup__text">
          To accept this proposal, please fill the form below.
        </p>
        <Form setResult={setResult} />
      </div>
    </div>
  ),
);
